import React from 'react';
import uuid from '../../utils/uuid';
import TextCellWrapper from '../TextCellWrapper/TextCellWrapper';
import styles from './ListCell.module.scss';
var BASE_KEY = "list-cell-".concat(uuid());
export default function ListCell(_ref) {
  var value = _ref.value;
  var isArray = Array.isArray(value);
  if (!isArray) {
    return /*#__PURE__*/React.createElement(TextCellWrapper, null, value);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, isArray ? /*#__PURE__*/React.createElement("div", null, value.map(function (entry, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(BASE_KEY, "-").concat(idx, "}"),
      className: styles.listCellItem
    }, /*#__PURE__*/React.createElement(TextCellWrapper, null, entry));
  })) : /*#__PURE__*/React.createElement(TextCellWrapper, null, value));
}